import React from 'react'
import _ from 'lodash'
import classes from './PatientInfo.css'
import FormattedDate from '../../components/FormattedDate'
import GetAge from '../../components/GetAge'
import EnrollmentDates from '../../components/EnrollmentDates'
import {
  truncate,
  getTemplateName,
} from '../../components/PatientInfoUtils'
import { getPhysicianName } from '../../containers/Utilities'
import { FormattedMessage } from 'react-intl'
import { getDateFormat } from '../../../common/dateUtils'
import { useIntlManger } from '../../../views/IntlManager'

export const PatientInfo = props => {
  const {
    columnTwoStyle,
    participant: {
      connectionStatus,
      connectionTemplateID,
      customParticipantID,
      dob,
      enrollment,
      fetching,
      firstName,
      id,
      lastName,
      orderingPhysician,
      prescribed,
      sex,
      notes,
    },
    ecgView = false,
    showAllDetails = true,
    orderingPractice,
    me,
  } = props

  const dateFormat = getDateFormat(me)
  const { locale } = useIntlManger()
  const infoTitleShortForNonEnglish = locale !== 'en' ? classes.infoTitleLong : classes.infoTitleShort
  return (
    <div className={`${classes.patientInfo} ${ecgView && classes.ecgView}`}>
      {showAllDetails &&
        <React.Fragment>
          <div className={classes.columnOne}>
            <div className={classes.row}>
              <div className={infoTitleShortForNonEnglish}>
                <FormattedMessage id="label.mrn" />:
              </div>
              <div className={classes.info}>
                {truncate(customParticipantID)}
              </div>
            </div>
            <div className={classes.row}>
              <div className={infoTitleShortForNonEnglish}>
                <FormattedMessage id="label.dob_short" />:
              </div>
              <div className={classes.info}>
                <FormattedDate date={dob} fmt={dateFormat} me={me}/>
                &nbsp;(<GetAge dob={dob} />)
              </div>
            </div>

            <div className={classes.row}>
              <div className={infoTitleShortForNonEnglish}>
                <FormattedMessage id="label.sex" />:
              </div>
              <div className={classes.info}>
                <FormattedMessage id={`label.${sex}`} />
              </div>
            </div>
          </div>
          <div
            className={classes.columnTwo}
            style={columnTwoStyle}
          >
            <div className={classes.row}>
              <div className={classes.infoTitleLong}>
                <FormattedMessage id="label.provider" />:
              </div>
              <div className={classes.info}>
                {orderingPhysician ? getPhysicianName(orderingPhysician.firstName, orderingPhysician.lastName) : '-'}
              </div>
            </div>

            <div className={classes.row}>
              <div className={classes.infoTitleLong}>
                <FormattedMessage id="label.Connection_Plan" />:
              </div>
              <div className={classes.info}>
                {getTemplateName(enrollment)}
              </div>
            </div>

            <div className={classes.row}>
              <div className={classes.infoTitleLong}>
                <FormattedMessage id="label.Connection_Period" />:
              </div>
              <div className={classes.info}>
                <EnrollmentDates
                  enrollment={enrollment}
                  dateFormat={dateFormat}
                  me={me}
                />
              </div>
            </div>

          </div>
        </React.Fragment>
      }
      {!showAllDetails &&
        <div className={classes.fullRow}>
          <div className={classes.row}>
            <div className={classes.infoTitleLong}>
              <FormattedMessage id="table.column.header.Ordering_Practice" />:
            </div>
            <div className={classes.info}>
              {orderingPractice.name}
            </div>
          </div>
        </div>
      }
      {!ecgView &&
        <div className={classes.fullRow}>
          <div className={classes.row}>
            <div className={infoTitleShortForNonEnglish}>
              <FormattedMessage id="label.notes" />:
            </div>
            <div className={classes.info}>
              {notes === null ? '-' : notes}
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default PatientInfo



// WEBPACK FOOTER //
// ./src/legacy/components/PatientInfo/PatientInfo.jsx